import { createPortal } from "react-dom";

const MobileMenuPortal = ({ children }) => {
  return createPortal(children, document.body);
};

export default MobileMenuPortal;
